var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadsetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 46,
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6086 0.881443C8.54596 1.60478 0.167969 11.3814 0.167969 22.5581V38.1681C0.167969 42.0414 3.26922 45.1681 7.11106 45.1681H9.42542C11.9712 45.1681 14.0541 43.0681 14.0541 40.5014V31.1681C14.0541 28.6014 11.9712 26.5014 9.42542 26.5014H4.7967V22.5114C4.7967 13.5514 11.6472 5.75811 20.5112 5.50144C29.6992 5.24478 37.1978 12.6414 37.1978 21.8348V26.5014H32.5691C30.0233 26.5014 27.9403 28.6014 27.9403 31.1681V40.5014C27.9403 43.0681 30.0233 45.1681 32.5691 45.1681H34.8834C38.7253 45.1681 41.8265 42.0414 41.8265 38.1681V21.8348C41.8265 9.77144 31.7359 0.0881092 19.6086 0.881443Z",
    fill: "#0078FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetIcon);
export default __webpack_public_path__ + "static/media/headset-icon.782f9dd397819cd336fc59d374911e62.svg";
export { ForwardRef as ReactComponent };